interface LoadingDotsProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'w-2 h-2',
  md: 'w-3 h-3',
  lg: 'w-4 h-4',
};

export default function LoadingDots({ size = 'md', className = '' }: LoadingDotsProps) {
  const dotSize = sizeMap[size];

  return (
    <div className={`flex items-center justify-center space-x-2 ${className}`}>
      <div
        className={`${dotSize} bg-[var(--color-primary-dark)] rounded-full animate-bounce [animation-delay:-0.3s]`}
      />
      <div
        className={`${dotSize} bg-[var(--color-primary-dark)] rounded-full animate-bounce [animation-delay:-0.15s]`}
      />
      <div className={`${dotSize} bg-[var(--color-primary-dark)] rounded-full animate-bounce`} />
    </div>
  );
}
